import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcPlusSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 18.0006C11 18.5529 11.4477 19.0006 12 19.0006C12.5523 19.0006 13 18.5529 13 18.0006L12.9999 13.0006H18.0005C18.5527 13.0006 19.0005 12.5529 19.0005 12.0006C19.0005 11.4483 18.5527 11.0006 18.0005 11.0006H12.9999L12.9998 6C12.9998 5.44771 12.5521 5 11.9998 5C11.4475 5 10.9998 5.44771 10.9998 6L10.9999 11.0006H6C5.44772 11.0006 5 11.4483 5 12.0006C5 12.5529 5.44772 13.0006 6 13.0006H10.9999L11 18.0006Z",
		fill: "inherit"
	})
});
export default SvgIcPlusSmallOl;
